import React from "react";
import { clubhouseActions } from "../../features/clubhouse/clubhouseSlice";

import { ILocalStorageUserData } from "../../types/users";
import ClubhouseTable from "./CoachTable";
import { redirect } from "react-router";

import { store } from "../../index";
import { globalActions } from "../../features/global/globalSlice";
import { useAppSelector } from "../../hooks/reduxHooks";
import AdminTable from "./AdminTable";
import { tournamentManagementActions } from "../../features/tourneymgmt/tournamentManagementSlice";

export const loader = async () => {
    const user = store.getState().auth.user as ILocalStorageUserData["user"];
    const settings = store.getState().global.settings;
    const clubhouseTeams = store.getState().clubhouse.teams;
    const clubhouseTournaments = store.getState().clubhouse.tournaments;
    const tournaments = store.getState().tournamentmanagement.tournaments;
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;

    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    const teamsPromise =
        user.userLevel <= 2
            ? clubhouseTournaments.length
                ? Promise.resolve()
                : store.dispatch(clubhouseActions.getTournaments(user.id))
            : clubhouseTeams.length
              ? Promise.resolve()
              : store.dispatch(clubhouseActions.getTeams({ userId: user.id }));

    const tournamentsPromise =
        user.userLevel <= 2
            ? tournaments.length
                ? Promise.resolve()
                : store.dispatch(tournamentManagementActions.getTournaments())
            : Promise.resolve();

    const masterTournamentsPromise =
        user.userLevel <= 2
            ? masterTournaments.length
                ? Promise.resolve()
                : store.dispatch(
                      tournamentManagementActions.getMasterTournaments(),
                  )
            : Promise.resolve();

    await Promise.all([
        teamsPromise,
        settingsPromise,
        tournamentsPromise,
        masterTournamentsPromise,
    ]);

    if (store.getState().clubhouse.teams.length === 1 && user.userLevel > 3) {
        const newLocation = `/coachs-clubhouse/team/${
            store.getState().clubhouse.selectedTeam?.id
        }`;

        return redirect(newLocation);
    } else {
        return null;
    }
};

const ClubhouseIndex = (): React.JSX.Element | undefined => {
    const { user } = useAppSelector(
        state => state.auth,
    ) as ILocalStorageUserData;

    return user?.userLevel <= 2 ? <AdminTable /> : <ClubhouseTable />;
};

export default ClubhouseIndex;
